export enum UserEvents {

  ActivityReported = 'ActivityReported',
  CreateActivityStarted = 'CreateActivityStarted',
  ActivityCreated = 'ActivityCreated',
  ActivityRsvped = 'ActivityRsvped',
  ActivityDeleted = 'ActivityDeleted',
  InvitationsSent = 'InvitationsSent',
  ActivityUpdated = 'ActivityUpdated',
  HomePageLoaded = 'HomePageLoaded',
  CreatePastActivityStarted = 'CreatePastActivityStarted'
}
